// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__Tng1w","offcanvasBody":"Navigation_offcanvasBody__vyVXg","navbarToggle":"Navigation_navbarToggle__TnqZ8","navbarOffcanvas":"Navigation_navbarOffcanvas__Z6tqh"};